const filterText = (scope, key, options = {}) =>
  I18n.t(key, {
    scope: `companies_overview.filters.${scope}`,
    ...options,
  })

export const filterTitle = (scope) => {
  return filterText(scope, 'title')
}

export const filterModalHelp = (scope) => {
  return filterText(scope, 'modal_help', { defaultValue: '' })
}
